import React from "react";
import styled from "@emotion/styled";

import Link from "@components/Navigation/Navigation.Footer.Links.List.Link";

interface LinksSectionProps {
  title: string,
  linksData: Object[]
}

const LinksSection: React.FC<LinksSectionProps> = (props) => {
  const { linksData } = props;
  const links = linksData.map(link => <Link key={link.text} href={link.href} text={link.text}/>);
  return (
    <>
      <LinksSectionContainer>
        <LinksSectionTitle>
          {props.title}
        </LinksSectionTitle>
        {links}
      </LinksSectionContainer>
    </>
  );
};

const LinksSectionTitle = styled.div`
  font-size: 30px;
  line-height: 165%;
  letter-spacing: -.05em;
  color: #ffffff;
  margin-bottom: 4px;
`;

const LinksSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 190px;
`;

export default LinksSection;
